import { FC } from 'react';
import { clsx } from 'clsx';

import * as style from './style.css';
import { appItems } from '../constants';

interface IMotivationDesktopProps {
  isBottom?: boolean;
}

export const MotivationDesktop: FC<IMotivationDesktopProps> = ({ isBottom }) => {
  return (
    <div className={clsx(style['container'], isBottom && style['container-bottom'])}>
      <div className={clsx(style['wrapper'], isBottom && style['wrapper-bottom'])}>
        <div className={clsx(style['content'], isBottom && style['content-bottom'])}>
          <div className={style['title']}> В приложении&nbsp;— быстрее и&nbsp;удобнее!</div>
          <div className={style['qr']}></div>
          <div className={style['apps']}>
            {appItems.map(item => (
              <div key={item.name} className={clsx(style['button'], style[item.className])}></div>
            ))}
          </div>
        </div>
        <div className={clsx(style['phone'], isBottom && style['phone-bottom'])}></div>
      </div>
    </div>
  );
};
